import { compose, lifecycle, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { checkExternalInitialization } from 'shared/utils/externalLoginUtils';

import AppLayout from './AppLayout';

export default compose(
  injectIntl,
  withRouter,
  withProps(({ location: { pathname } }) => ({
    hideHeader: pathname.includes('appointment/'),
    hideFooter: checkExternalInitialization(),
    isReactNative: /RnUmmanu/.test(navigator.userAgent),
  })),

  lifecycle({
    componentWillMount() {
      window.intl = this.props.intl;
    },
  }),
)(AppLayout);
